const dropdownComponents = document.querySelectorAll('[data-dropdown-component]');

dropdownComponents.forEach((dropdownComponent) => {
    let dropdowns = document.querySelectorAll('.dropdown'),
    dropdownOptions = dropdownComponent.querySelectorAll('.dropdown__option'),
    dropdownHeading = dropdownComponent.querySelector('.dropdown__heading')

    let open = el => el.classList.add('dropdown--open')

    let close = el => el.classList.remove('dropdown--open')

    let toggle = el => el.classList.contains('dropdown--open') ? close(el) : open(el)

    let closeAllExcept = el => {
        Array.from(dropdowns).forEach(dropdown => {
            if (el) {
                if (dropdown !== el) {
                    close(dropdown)
                }
            } else {
                close(dropdown)
            }
        })
    }

    dropdownComponent.addEventListener('click', ev => {
        closeAllExcept(dropdownComponent)

        toggle(dropdownComponent)
        ev.stopPropagation()
    }, false)

    document.addEventListener('click', ev => closeAllExcept(ev.target.closest('.dropdown')))

    document.addEventListener('keydown', ev => {
        if (ev.code === 'Escape') {
            closeAllExcept(false)
        }
    })

    Array.from(dropdownOptions).forEach(dropdownOption => {
        dropdownOption.addEventListener('click', ev => {
            Array.from(dropdownOptions).forEach(dropdownOption => dropdownOption.classList.remove('dropdown__option--selected'))

            dropdownOption.classList.add('dropdown__option--selected')
            dropdownComponent.classList.add('dropdown--selected')
            dropdownHeading.innerHTML = dropdownOption.innerHTML
        }, false)
    })
})